import WebFontLoader from 'webfontloader';
import defaultTheme from '@mui/material/styles/defaultTheme.js';

import {round} from './utils.js';

const {pxToRem} = defaultTheme.typography;

export const DEFAULT_FONT = 'Inter';
export const DEFAULT_FONT_WEIGHTS = [400, 500, 600, 700];
export const DEFAULT_FONT_FAMILY = `'${DEFAULT_FONT}', sans-serif`;

// Load Web Fonts
export const loadFonts = () =>
  WebFontLoader.load({
    google: {
      families: [`${DEFAULT_FONT}:${DEFAULT_FONT_WEIGHTS.toString()}`],
    },
  });

/**
 * Typography based on design:
 * https://planet.invisionapp.com/d/main/#/console/18949169/407115529/preview
 * Modified for App use
 */
export default {
  body1: {
    letterSpacing: `${round(-0.2 / 16)}em`,
    lineHeight: round(22 / 16),
  },
  body2: {
    letterSpacing: `${round(-0.2 / 14)}em`,
    lineHeight: round(20 / 14),
  },
  button: {
    fontSize: pxToRem(14),
    fontWeight: 700,
    textTransform: 'none',
  },
  caption: {
    fontSize: pxToRem(13),
    letterSpacing: `${round(0.2 / 13)}em`,
    lineHeight: round(18 / 13),
  },
  fontFamily: DEFAULT_FONT_FAMILY,
  h1: {
    fontSize: pxToRem(86),
    fontWeight: 700,
    letterSpacing: `${round(-0.2 / 86)}em`,
    lineHeight: round(90 / 86),
  },
  h2: {
    fontSize: pxToRem(54),
    fontWeight: 400,
    letterSpacing: `${round(-0.2 / 54)}em`,
    lineHeight: round(58 / 54),
  },
  h3: {
    fontSize: pxToRem(42),
    fontWeight: 700,
    letterSpacing: `${round(-0.2 / 42)}em`,
    lineHeight: round(46 / 42),
  },
  h4: {
    fontSize: pxToRem(32),
    fontWeight: 700,
    letterSpacing: `${round(-0.2 / 32)}em`,
    lineHeight: round(35 / 32),
  },
  h5: {
    fontSize: pxToRem(26),
    fontWeight: 700,
    letterSpacing: `${round(-0.2 / 26)}em`,
    lineHeight: round(28 / 26),
  },
  h6: {
    fontSize: pxToRem(20),
    fontWeight: 400,
    letterSpacing: `${round(-0.2 / 20)}em`,
    lineHeight: round(26 / 20),
  },
  overline: {
    fontSize: pxToRem(13),
    fontWeight: 700,
    letterSpacing: `${round(1 / 13)}em`,
    lineHeight: round(24 / 13),
  },
  subtitle1: {
    fontWeight: 700,
  },
  subtitle2: {
    fontWeight: 700,
  },
};
